const instructionalAreas = {
    kindergarten: "K",
    "1st grade": "1st",
    "2nd grade": "2nd",
    "3rd grade": "3rd",
    "4th grade": "4th",
    "5th grade": "5th",
    "6th grade": "6th"
};

const teacherGradeNameFullGradeName = {
    K: "Kindergarten",
    "1st": "1st Grade",
    "2nd": "2nd Grade",
    "3rd": "3rd Grade",
    "4th": "4th Grade",
    "5th": "5th Grade",
    "6th": "6th Grade"
};

export const validTeacherGradeName = (candidate) => {
    if (typeof candidate !== "string") return false;
    return candidate in teacherGradeNameFullGradeName;
};

export const getFullGradeName = (prefixTeacherGradeName) => {
    return teacherGradeNameFullGradeName[prefixTeacherGradeName];
};

export const getTeacherGradeNamePrefixFromInstructionalArea = (instructionalArea) => {
    return instructionalAreas[instructionalArea?.toLowerCase()];
};

/**
 * Display guardian view percentage from the teachers API as-is.
 * @param {*} value
 * @returns {string}
 */
export const formatPercentageViewed = (value) => {
    if (value == null || value === "") return "Not Available";
    return String(value);
};

/**
 * Keep teachers that have a roster and/or an EPR created.
 * Drops empty shells (no students and no grading profile).
 * @param {Array} [teachers]
 * @returns {Array}
 */
export const filterTeachersWithRosterOrEpr = (teachers = []) =>
    teachers.filter((t) => (t?.studentCount ?? 0) > 0 || (t?.gradingProfileId ?? 0) > 0);

const RELEASED_STATUS = "READY_FOR_RELEASE";
const NOT_AVAILABLE = "Not Available";

const parsePercentageViewed = (value) => {
    if (value == null || value === "") return null;
    const parsed = Number.parseFloat(String(value).replace("%", ""));
    return Number.isFinite(parsed) ? parsed : null;
};

/**
 * Summary sentence for guardian views of released report cards.
 * @param {number} released
 * @param {number} viewed
 * @param {"school year"|"semester"} periodLabel
 * @returns {string}
 */
const formatGuardianViewSummary = (released, viewed, periodLabel) => {
    if (released === 0) return NOT_AVAILABLE;
    const percent = ((viewed / released) * 100).toFixed(1);
    const verb = viewed === 1 ? "was" : "were";
    return `Of <strong>${released}</strong> report cards released for the ${periodLabel}, <strong>${viewed}</strong> ${verb} viewed by guardians or <strong>${percent}%</strong>.`;
};

const summarizeSlice = (teachers, periodLabel) => {
    let released = 0;
    let viewed = 0;

    teachers.forEach((teacher) => {
        if (teacher?.releaseStatus !== RELEASED_STATUS) return;
        const studentCount = teacher?.studentCount ?? 0;
        if (studentCount <= 0) return;
        released += studentCount;
        const pct = parsePercentageViewed(teacher?.percentageViewed) ?? 0;
        viewed += Math.round((studentCount * pct) / 100);
    });

    return {
        summary: formatGuardianViewSummary(released, viewed, periodLabel)
    };
};

/**
 * School-level rollup: School Year (ytd) + selected semester.
 * Eligible = roster or EPR created. Last-name filter is not applied.
 * Summary = of released report cards, how many were viewed by guardians.
 * @param {Array} [teachers]
 * @param {string} selectedSemesterName
 * @returns {{ ytd: { summary: string }, semester: { summary: string } }}
 */
export const computeLocationRollup = (teachers = [], selectedSemesterName) => {
    const eligible = filterTeachersWithRosterOrEpr(teachers);
    const semesterTeachers = eligible.filter((t) => t?.timePeriod === selectedSemesterName);

    return {
        ytd: summarizeSlice(eligible, "school year"),
        semester: summarizeSlice(semesterTeachers, "semester")
    };
};
